var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for the AV-03 corpus-quality dashboard (CZNA-330).
 *
 * Read-only over the persisted `validation_run` snapshots. Starting a run reuses
 * the existing AV-01 `revalidate` service; this file only reads the dashboard
 * data. Follows the project `useOkapiKy()` pattern — callers capture `ky` by
 * closure / use react-query, never put it in effect deps (MEMORY).
 */
import { getHeaders } from './apiUtils';
import { API_PATHS, CZNA_CORPUS_CHECK_FINDINGS } from '../types/apiPaths';
/**
 * Latest completed run (dashboard header). Resolves to `null` when the backend
 * returns 204 (no run has been recorded yet).
 */
export var getLatestRun = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get(API_PATHS.CZNA_VALIDATION_QUALITY_LATEST, {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (response.status === 204)
                    return [2 /*return*/, null];
                return [2 /*return*/, response.json()];
        }
    });
}); };
/** Paginated run history (newest first). */
export var getRuns = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var search;
        var _a, _b;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            search = new URLSearchParams();
            search.set('offset', String((_a = params.offset) !== null && _a !== void 0 ? _a : 0));
            search.set('limit', String((_b = params.limit) !== null && _b !== void 0 ? _b : 20));
            return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_VALIDATION_QUALITY_RUNS, "?").concat(search), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/** Full detail of one run (by_category panels + by_rule top-failing-rules). */
export var getRunDetail = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_VALIDATION_QUALITY_RUNS, "/").concat(id), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/** Oldest-first trend points for the quality trend chart. */
export var getTrend = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, limit) {
        var search;
        if (limit === void 0) { limit = 24; }
        return __generator(this, function (_a) {
            search = new URLSearchParams();
            search.set('limit', String(limit));
            return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_VALIDATION_QUALITY_TREND, "?").concat(search), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/** CZNA-1620 — whether the validation rules changed after the last full revalidation. */
export var getRulesetStatus = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(API_PATHS.CZNA_VALIDATION_QUALITY_RULESET_STATUS, {
                headers: getHeaders(),
            }).json()];
    });
}); };
/** CZNA-1217 — last stored corpus-check run; `null` on 204 (the checks never ran). */
export var getLatestCorpusChecks = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get(API_PATHS.CZNA_CORPUS_CHECKS_LATEST, {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (response.status === 204)
                    return [2 /*return*/, null];
                return [2 /*return*/, response.json()];
        }
    });
}); };
/** CZNA-1217 — one page of a check's violations in a stored run. */
export var getCorpusCheckFindings = function (ky_1, jobId_1, checkCode_1) {
    var args_1 = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args_1[_i - 3] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1, jobId_1, checkCode_1], args_1, true), void 0, function (ky, jobId, checkCode, params) {
        var search;
        var _a, _b;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            search = new URLSearchParams();
            search.set('checkCode', checkCode);
            search.set('offset', String((_a = params.offset) !== null && _a !== void 0 ? _a : 0));
            search.set('limit', String((_b = params.limit) !== null && _b !== void 0 ? _b : 50));
            // CZNA-1408 — filtered on the server, so the count and the paging are of that type.
            if (params.recordType)
                search.set('recordType', params.recordType);
            return [2 /*return*/, ky.get("".concat(CZNA_CORPUS_CHECK_FINDINGS(jobId), "?").concat(search), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
